import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { EndPoints } from '../EndPoints';
import { Sector, SectorFilters } from '../../models/Sector';

const useSectorService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetSectors, setFetchingGetSectors] = useState(false);
    const [fetchingCreateSector, setFetchingCreateSector] = useState(false);
    const [fetchingStoreSector, setFetchingStoreSector] = useState(false);
    const [fetchingEditSector, setFetchingEditSector] = useState(false);
    const [fetchingUpdateSector, setFetchingUpdateSector] = useState(false);
    const [fetchingDeleteSector, setFetchingDeleteSector] = useState(false);
    const [fetchingActiveSector, setFetchingActiveSector] = useState(false);

    const getSectors = (filters: SectorFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = `${EndPoints.SECTORS.GET_SECTORS}?${queryString}`;

        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetSectors
        });
    };

    const createSector = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.SECTORS.GET_SECTORS,
            setFetching: setFetchingCreateSector
        });
    };

    const storeSector = (sector: Sector, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.SECTORS.STORE_SECTOR,
            body: sector,
            setFetching: setFetchingStoreSector
        });
    };

    const editSector = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.SECTORS.EDIT_SECTOR.replace(':id', id.toString()),
            setFetching: setFetchingEditSector
        });
    };

    const updateSector = (id: number, sector: Sector, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.SECTORS.UPDATE_SECTOR.replace(':id', id.toString()),
            body: sector,
            setFetching: setFetchingUpdateSector
        });
    };

    const deleteSector = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.SECTORS.DELETE_SECTOR.replace(':id', id.toString()),
            setFetching: setFetchingDeleteSector
        });
    };

    const activeSector = (id: number, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.SECTORS.ACTIVE_SECTOR.replace(':id', id.toString()),
            setFetching: setFetchingActiveSector
        });
    };

    return {
        // states
        fetchingGetSectors,
        fetchingCreateSector,
        fetchingStoreSector,
        fetchingEditSector,
        fetchingUpdateSector,
        fetchingDeleteSector,
        fetchingActiveSector,
        // methods
        getSectors,
        createSector,
        storeSector,
        editSector,
        updateSector,
        deleteSector,
        activeSector
    };
};

export default useSectorService;
